import {StyledIcon, StyledUl, StyledLi} from './styled';
import Text from '@planday-corp/ui/text/Text';
import React from 'react';

interface BulletListProps {
  items: string[];
}

export default function BulletList({items}: BulletListProps) {
  return (
    <StyledUl>
      {items.map((item, index) => (
        <StyledLi key={index}>
          <StyledIcon iconName="plusCircle" color="turquoise50" />
          <Text value={item} size="label" />
        </StyledLi>
      ))}
    </StyledUl>
  );
}
